// import auth0 from 'auth0-js';
// import config from '../../config';
// import { UsersAPI } from '../../components/apis';
// import { useDispatch } from 'react-redux';
// import allActions from '../../actions';
// import {Auth0Provider as auth0} from '@auth0/auth0-react';

class Auth {
  
  // auth0 = new auth0.WebAuth({
  //   domain: config.get('auth0.domain'),
  //   audience: config.get('auth0.audience'),
  //   clientID: config.get('auth0.clientID'),
  //   redirectUri: config.get('auth0.callbackURL'),
  //   responseType: 'token id_token',
  // });

  // Initialize authorization process with Auto0 in order to let the user input its user and password into Sinexiar-Auth0 login page.
  // loginAuth0Authorize = () => {
  //   console.log("Sending to LOGIN page in Auth0!!!")
  //   this.auth0.authorize();
  // }

  // Remove Client variables from localStorage.
  cleanStorage = () => {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token');
    localStorage.removeItem('id_token');
    localStorage.removeItem('expires_at');
    localStorage.removeItem('profile');
    localStorage.removeItem('sessionUser');
  }

  // // Clean locale storage variables, logout from Auth0 and redirect to login Sinexiar-Auth0 loging page.
  // logout = () => {
    
  //   this.cleanStorage();

  //   this.auth0.logout({
  //     clientID: config.get("auth0.clientID"),
  //     returnTo: config.get("auth0.loginURL"),
  //   })

  //   debugger
  // }

  // handleAuthentication = () => {
  //   return new Promise((resolve, reject) => {
  //     this.auth0.parseHash((err, authResult) => {
  //       debugger
  //       if (err) {
  //         return reject(err);
  //       }
  //       if (authResult && authResult.accessToken && authResult.idToken) {
  //         this.setSession(authResult);
  //         resolve(authResult)
  //       } else {
  //         reject("Authentication result lacks on required data");
  //       }
  //     });
  //   });
  // }

  setSession(parameters) {
    // let expiresAt = JSON.stringify(
    //   authResult.expiresIn * 1000 + new Date().getTime()
    // );
    localStorage.setItem('access_token', parameters.accessToken);
    localStorage.setItem('id_token', parameters.idToken);
    // localStorage.setItem('expires_at', expiresAt);
    localStorage.setItem('sessionUser', parameters.fullUser);
  }

  getAccessToken() {
    return localStorage.getItem('access_token');
    //return localStorage.getItem('id_token');
  }

  getSessionUser() {
      return JSON.parse(localStorage.getItem('sessionUser'));
  }

  // Get the account of logged user
  // getSessionUserAccount() {
  //   const user = this.getSessionUser();
  //   return user.accounts[0];
  // }

  // getProfile() {
  //   const self = this;
  //   return new Promise((resolve, reject) => {
  //     const profile = localStorage.getItem('profile');
  //     if (profile !== null) {
  //       resolve(JSON.parse(localStorage.getItem('profile')));
  //     }
  //     setTimeout(() => {

  //       if(self.getAccessToken() != null){
  //           this.auth0.client.userInfo(self.getAccessToken(), (err, profile) => {
  //             if (err) {
  //               reject(err);
  //             } else {
  //               const userAPI = new UsersAPI(self.getAccessToken());

  //               userAPI.getSessionUser().then(user => {

  //                 var rol_id = null;
  //                 var roles = user.roles;
  //                 for (var j = 0; j < roles.length; j++) {
  //                    if(rol_id == null || roles[j].id < rol_id){
  //                       rol_id = roles[j].id;
  //                    }
  //                 }

  //                 user.rol_id = rol_id;
  //                 localStorage.setItem('sessionUser', JSON.stringify(user));
  //               }).catch(err => {
  //                 localStorage.setItem('sessionUser', null);
  //               });

  //               localStorage.setItem('profile', JSON.stringify(profile));
  //               resolve(profile);
  //             }
  //           });
  //       }

  //     }, 1000);
  //   });
  // }

  // isAuthenticated = () => {
  //   if (!localStorage.getItem('expires_at')) {
  //     return false;
  //   }
  //   // Check whether the current time is past the
  //   // access token's expiry time
  //   let expiresAt = JSON.parse(localStorage.getItem('expires_at'));
  //   return new Date().getTime() < expiresAt;
  // }
}

const auth = new Auth();

export default auth;